<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i">
<div class="section level2" id="section-1">
<h2><br/><br/><br/>2</h2>
<p><br/><br/><br/>When I stepped outside, the palm trees were shaking and rattling back and forth hard and wide. The wind was strong. People scattered around and scurried by.</p>
<p>“A hurricane is approaching,” my friend said.</p>
<p>She brought me in some hot meal, and I ate it, just two bites, filled with honey, hot corn and wheat. I ate it off of the wooden spoon someone had carved out of bamboo and lashed with coconut shell.</p>
<p>“We need your submarine,” she stated.</p>
<p>“Who needs my submarine?” I asked.</p>
<p>“A few of my friends,” she replied, “Don’t worry. Everyone is friendly with you.”</p>
<p>“Okay. I will go secure your landing and get it prepped for submarine mode.” Right now, it was in yacht mode, sitting out in the middle of the grey rocking waters. “Meet me in a while if it gets too hard, and I don’t see you or your friends, unless you want to come with me now?” I asked.</p>
<p>“I just need to get some things ready and my stuff,” she said.</p>
<p>“Okay.”</p>
<p>In a minute, I was done with breakfast and picked up the book bag with the books and the supplies in it. I grabbed some of the food we had stored, put it in a small bag and carried it out the door to check out the village during the pre-hurricane preparations.</p>
<p>Outside, everything was as described. It was as if mayhem was taking over as raindrops fell. People began running by me with animal skins and babies in their hands. People hid their cloths and clothing, some of them dressed like scavengers and others dressed almost civilly and modern. We ran around like lunatics, putting food and skins under the tents and tarps that were set up.</p>
<p>I helped a mother scoop up her belongings, the food that she was cooking and her two little kids as they were playing outside. When it started coming down hard, I went back into the tent, and it was big enough for a couple of beds and for some people to walk around in. There was a lantern and a table. The lantern was on. It was fluorescent and took the rechargeable batteries that we had. There were solar panels set up that produced electricity in a cabin nearby. People charged their batteries there.</p>
<p>Jess, my friend, walked about and breathed out as she hoisted her foot, inhaled and fixed her shoelaces before dropping her leg back down to the dirt floor.</p>
<p>“It’s coming down hard,” I said.</p>
<p>“Can tell; sounds like it,” she said.</p>
<p>“Want to wait for it to let up?” I asked.</p>
<p>“Maybe,” she said.</p>
<p>“That is better than nothing.”</p>
<p>“Then show me.”</p>
<p>“What?” I asked.</p>
<p>“You know.”</p>
<p>“How I take chances?” We embraced and kissed.</p>
<p>“That’s right,” she said. “Show me how you take chances.”</p>
<p>In a moment or two, we were lying on the bed, undressing each other, and the rain spattered hard on the roof of the tent. People’s footsteps hurried by repeatedly. And then again, the rain fell harder, and the wind ceased.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?691f2ad7